import { Box, Link } from "@mui/material"
import { AddOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

interface AddDataRowProps {
  label: string
  onClick: () => void
  "data-testid"?: string
}

export const AddDataRow: FC<AddDataRowProps> = ({ label, onClick, "data-testid": dataTestId }) => (
  <Box className='flex items-center justify-end'>
    <Link
      component='button'
      type='button'
      onClick={onClick}
      className='flex items-center gap-1 text-primary no-underline'
      sx={{ cursor: "pointer" }}
      data-testid={dataTestId}
    >
      <AddOutlined fontSize='small' />
      <span>{label}</span>
    </Link>
  </Box>
)
